import type { Tables } from "@msuite/utils/types";
import type { ReactNode } from "react";
import type { GetFileAnnotations, SaveFileAnnotations } from "../lightbox/shared";
import type { UseRemoteFileUrl } from "../types";
import { FileInspectorModalImageItem } from "./file-inspector-modal-image-item";

/** Props Interface */
interface FileInspectorModalItemProps {
	file: Tables<"files">;
	useRemoteFileUrl?: UseRemoteFileUrl;
	getAnnotations?: GetFileAnnotations;
	onSaveAnnotations?: SaveFileAnnotations;
	hasAnnotations?: boolean;
	children: ReactNode;
}

export function FileInspectorModalItem({
	file,
	useRemoteFileUrl,
	getAnnotations,
	onSaveAnnotations,
	hasAnnotations,
	children,
}: FileInspectorModalItemProps) {
	/** Computed */
	const isImage = file.contentType.startsWith("image/");

	/** Guard */
	if (isImage && useRemoteFileUrl) {
		return (
			<FileInspectorModalImageItem
				file={file}
				useRemoteFileUrl={useRemoteFileUrl}
				getAnnotations={getAnnotations}
				onSaveAnnotations={onSaveAnnotations}
				hasAnnotations={hasAnnotations}
			>
				{children}
			</FileInspectorModalImageItem>
		);
	}

	/** Render */
	return <>{children}</>;
}
